export default "__VITE_ASSET__BPgUwRdK__"